class RevelPassword {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        document.querySelectorAll('[data-revel-password]').forEach(el => {
            new RevelPasswordItem(el)
        })
    }
}

class RevelPasswordItem {
    // The wrapper and the eye button are rendered by the template, NOT built
    // here. This component used to create them and move the <input> into the
    // new wrapper with insertBefore + appendChild - detaching and re-inserting
    // a password field is what breaks Chrome's password manager, which drops
    // the value it just filled from a generated-password suggestion. Nothing
    // in here may mutate the input's position in the DOM.
    constructor(el) {
        this.el = el
        // parentElement first: the input itself also carries .revel-password
        // (the CSS sizes it through that class), so closest() from the input
        // would match the input.
        this.elParent = el.parentElement && el.parentElement.closest('.revel-password')
        if (!this.elParent) return
        this.elAction = this.elParent.querySelector('.revel-password-action')
        if (!this.elAction) return

        this.elAction.addEventListener('click', () => {
            this.togglePasswordAction()
        })
    }
    togglePasswordAction() {
        if (this.el.type === "password") {
            this.el.type = "text";
            this.elParent.classList.add('revel-password--is-show');
        } else {
            this.el.type = "password";
            this.elParent.classList.remove('revel-password--is-show');
        }
    }
}

export default RevelPassword
